import * as React from 'react';
import { PassengerSwitch } from '../../../Passenger/components/Field/PassengerSwitch/PassengerSwitch';

interface Props {
	value?: string;
	onChange: (value: string) => void;
	onBlur: () => void;
	className?: string;
	error?: string;
}

const GenderSwitch: React.FunctionComponent<Props> = props => {
	return (
		<PassengerSwitch
			name={'sex'}
			className={props.className}
			value={props.value}
			options={[
				{ label: 'male', value: 'Male' },
				{ label: 'female', value: 'Female' }
			]}
			onChange={value => props.onChange(value)}
			onBlur={props.onBlur}
			error={props.error || null}
		/>
	);
};

export default GenderSwitch;
